import { useAuth as e, useMeQuery as t } from "@maat/store-auth";
import { WorkspaceDeveloperEnvironment as n } from "@maat/api-main/types";
import { useCallback as r, useSyncExternalStore as i } from "react";
//#region src/workspaceDeveloper/useDeveloperEnvironment.ts
var a = "developer:environment", o = n.Live, s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Map(), l = null, u = (e) => `${a}:${e.userId ?? "anonymous"}:${e.workspaceId ?? "none"}`, d = (e) => e === n.Live || e === n.Sandbox, f = (e) => {
	l = e, c.clear(), s.forEach((e) => e());
}, p = (e) => {
	e ? c.delete(e) : c.clear(), s.forEach((e) => e());
}, m = (e) => {
	let t = u(e), n = c.get(t);
	if (n) return n;
	try {
		let e = l?.read(t);
		if (d(e)) return c.set(t, e), e;
	} catch {}
	return o;
}, h = (e, t) => {
	let n = u(e);
	c.set(n, t);
	try {
		l?.write(n, t);
	} catch {}
	s.forEach((e) => e());
}, g = (e) => (s.add(e), () => {
	s.delete(e);
}), _ = () => {
	let { isAuthenticated: a, activeWorkspaceId: s } = e(), { data: c } = t(a), l = c?.user?.id ?? null, u = {
		userId: l,
		workspaceId: s
	}, d = i(g, () => m(u), () => o);
	return {
		environment: d,
		setEnvironment: r((e) => h({
			userId: l,
			workspaceId: s
		}, e), [l, s]),
		isSandbox: d === n.Sandbox
	};
};
//#endregion
export { u as developerEnvironmentKey, p as notifyDeveloperEnvironmentChanged, m as readDeveloperEnvironment, f as registerDeveloperEnvironmentStorage, h as setDeveloperEnvironment, _ as useDeveloperEnvironment };
